<label class="switch">
  <input type="checkbox" class="switch-checkbox" [name]="name" [checked]="value" [disabled]="disabled" (change)="toggle(); onChange(value)" />
  <div class="switch-field"></div>
</label>
